"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");

var dateToBigNumber = contract_wrappers_1.conversionUtils.dateToBigNumber;
/**
 * Procedure that modifies data for a list of (potential) tokenholders. The data that can be modified is:
 *
 * - KYC data (sale/buy lockup dates and KYC expiry)
 * - Whether the tokenholder is accredited
 * - Whether the tokenholder can buy from an STO
 */

var ModifyTokenholderData =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ModifyTokenholderData, _Procedure_1$Procedur);

  function ModifyTokenholderData() {
    var _this;

    _classCallCheck(this, ModifyTokenholderData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModifyTokenholderData).apply(this, arguments));
    _this.type = types_1.ProcedureType.ModifyTokenholderData;
    return _this;
  }
  /**
   * Update tokenholder data for a subset of addresses
   *
   * Note that this procedure will fail if:
   * - You're trying to set the dates to 0 (there is a special "RevokeKyc" procedure for that)
   * - The Security Token doesn't exist
   * - There is no difference between the "new" data and the data already present in the contract
   */


  _createClass(ModifyTokenholderData, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var _this$args, symbol, tokenholderData, _this$context, contractWrappers, factories, securityToken, tokenholders, gtmModule, investors, canSendAfter, canReceiveAfter, expiryTime, investorsForFlags, flag, value, uniqueInvestorsForFlags, allAffectedTokenholders, securityTokenId, newTokenholders, _ref4, _ref5, _ref6, _ref7;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, tokenholderData = _this$args.tokenholderData;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;

                if (!tokenholderData.some(function (_ref) {
                  var canReceiveAfter = _ref.canReceiveAfter,
                      canSendAfter = _ref.canSendAfter,
                      kycExpiry = _ref.kycExpiry;
                  return [canReceiveAfter, canSendAfter, kycExpiry].some(function (date) {
                    return date.getTime() === 0;
                  });
                })) {
                  _context3.next = 4;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "Cannot set dates to epoch. If you're trying to revoke a tokenholder's KYC, use .revokeKyc()"
                });

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context3.next = 14;
                return factories.securityTokenFactory.fetch(entities_1.SecurityToken.generateId({
                  symbol: symbol
                }));

              case 14:
                securityToken = _context3.sent;
                _context3.next = 17;
                return securityToken.tokenholders.getTokenholders();

              case 17:
                tokenholders = _context3.sent;
                _context3.next = 20;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 20:
                gtmModule = _context3.sent[0];

                if (gtmModule) {
                  _context3.next = 23;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: "General Transfer Manager for token \"".concat(symbol, "\" isn't enabled. Please report this issue to the Polymath team")
                });

              case 23:
                investors = [];
                canSendAfter = [];
                canReceiveAfter = [];
                expiryTime = [];
                investorsForFlags = [];
                flag = [];
                value = [];
                tokenholderData.forEach(function (_ref2) {
                  var address = _ref2.address,
                      sendDate = _ref2.canSendAfter,
                      receiveDate = _ref2.canReceiveAfter,
                      kycExpiry = _ref2.kycExpiry,
                      isAccredited = _ref2.isAccredited,
                      canBuyFromSto = _ref2.canBuyFromSto;
                  var thisTokenholder = tokenholders.find(function (_ref3) {
                    var tokenholderAddress = _ref3.address;
                    return tokenholderAddress === address;
                  });

                  if (!thisTokenholder || !dateToBigNumber(thisTokenholder.canSendAfter).eq(dateToBigNumber(sendDate)) || !dateToBigNumber(thisTokenholder.canReceiveAfter).eq(dateToBigNumber(receiveDate)) || !dateToBigNumber(thisTokenholder.kycExpiry).eq(dateToBigNumber(kycExpiry))) {
                    investors.push(address);
                    canSendAfter.push(sendDate);
                    canReceiveAfter.push(receiveDate);
                    expiryTime.push(kycExpiry);
                  } // Only update flags that will actually change
                  // one tokenholder entry per modified flag
                  // we will sometimes have the same tokenholder twice in the array


                  if (!thisTokenholder || thisTokenholder.isAccredited !== isAccredited) {
                    investorsForFlags.push(address);
                    flag.push(contract_wrappers_1.FlagsType.IsAccredited);
                    value.push(isAccredited);
                  }

                  if (!thisTokenholder || thisTokenholder.canBuyFromSto !== canBuyFromSto) {
                    investorsForFlags.push(address);
                    flag.push(contract_wrappers_1.FlagsType.CanNotBuyFromSto);
                    value.push(!canBuyFromSto); // negated since the contract flag represents the opposite
                  }
                });
                uniqueInvestorsForFlags = lodash_1.uniq(investorsForFlags);
                allAffectedTokenholders = lodash_1.uniq([].concat(investors, _toConsumableArray(uniqueInvestorsForFlags)));
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });

                if (!(investors.length > 0)) {
                  _context3.next = 40;
                  break;
                }

                _context3.next = 37;
                return this.addTransaction(gtmModule.modifyKYCDataMulti, {
                  tag: types_1.PolyTransactionTag.ModifyKycDataMulti,
                  resolvers: [function () {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var refreshingTokenholders, fetchingTokenholders;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              refreshingTokenholders = investors.map(function (investor) {
                                return factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: investor
                                }));
                              });
                              _context.next = 3;
                              return Promise.all(refreshingTokenholders);

                            case 3:
                              if (!(investorsForFlags.length === 0)) {
                                _context.next = 6;
                                break;
                              }

                              fetchingTokenholders = allAffectedTokenholders.map(function (tokenholder) {
                                return factories.tokenholderFactory.fetch(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: tokenholder
                                }));
                              });
                              return _context.abrupt("return", Promise.all(fetchingTokenholders));

                            case 6:
                              return _context.abrupt("return", []);

                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }]
                })({
                  investors: investors,
                  canSendAfter: canSendAfter,
                  canReceiveAfter: canReceiveAfter,
                  expiryTime: expiryTime
                });

              case 37:
                _ref4 = _context3.sent;
                _ref5 = _slicedToArray(_ref4, 1);
                newTokenholders = _ref5[0];

              case 40:
                if (!(investorsForFlags.length > 0)) {
                  _context3.next = 46;
                  break;
                }

                _context3.next = 43;
                return this.addTransaction(gtmModule.modifyInvestorFlagMulti, {
                  tag: types_1.PolyTransactionTag.ModifyInvestorFlagMulti,
                  resolvers: [function () {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee2() {
                      var refreshingTokenholders, fetchingTokenholders;
                      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              // Only consider one occurence of each investor address
                              refreshingTokenholders = uniqueInvestorsForFlags.map(function (investor) {
                                return factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: investor
                                }));
                              });
                              _context2.next = 3;
                              return Promise.all(refreshingTokenholders);

                            case 3:
                              fetchingTokenholders = allAffectedTokenholders.map(function (tokenholder) {
                                return factories.tokenholderFactory.fetch(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: tokenholder
                                }));
                              });
                              return _context2.abrupt("return", Promise.all(fetchingTokenholders));

                            case 5:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                  }]
                })({
                  investors: investorsForFlags,
                  flag: flag,
                  value: value
                });

              case 43:
                _ref6 = _context3.sent;
                _ref7 = _slicedToArray(_ref6, 1);
                newTokenholders = _ref7[0];

              case 46:
                if (newTokenholders) {
                  _context3.next = 48;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'Modify tokenholder data failed: Nothing to modify'
                });

              case 48:
                return _context3.abrupt("return", newTokenholders);

              case 49:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));
    }
  }]);

  return ModifyTokenholderData;
}(Procedure_1.Procedure);

exports.ModifyTokenholderData = ModifyTokenholderData;